/** 是否关闭埋点上报 */
export const isDisableTrackM = () => {
  // const domain = window.location.host;
  // return ["www.oytraining.top", "www.kpgohg.top", "www.fatml.top", "localhost"].includes(domain);
  return true;
};


// WEBPACK FOOTER //
// ./src/util/experiment.js